export default function GearListContent() {
  return (
    <>
      <h2>Why this template exists</h2>
      <p>
        The Need / Want / Have / Skip shape isn't ours. Hikers,
        photographers, stage crews, and cyclists all reinvent it
        independently the first time they realize a checklist alone isn't
        enough. Every trip requires the same four decisions: what's
        essential, what would be nice, what's already in the bag, and what
        we're leaving behind on purpose so we don't carry it.
      </p>

      <h2>When to use this template</h2>
      <p>
        Backpacking trips, camera-shoot prep, band tour logistics, wedding
        packing, moving day, kids' weekend at the grandparents'. Any
        occasion where multiple people are contributing to a shared bag
        and you want to avoid the classic dysfunction of "I thought
        <em> you</em> were bringing the tent."
      </p>

      <h2>Not the right shape for</h2>
      <p>
        Recurring purchases or things you own year-round. Gear List is
        trip-specific, a snapshot in time. If you want an inventory of
        what's in the gear closet, that's a different board (and probably
        a spreadsheet).
      </p>

      <h2>How to run it</h2>
      <p>
        Start with a brain dump into Need: every item that would be
        catastrophic to forget. Move things down to Want as you realize
        they're not essential. Anything you already own moves to Have. The
        Skip column is where the discipline lives; named items you{" "}
        <em>considered</em> and decided against, so they don't sneak back
        into the pile the night before you leave.
      </p>

      <h2>Common pitfalls</h2>
      <p>
        Wants creep into Needs the night before departure. Combat this by
        dating the board; anything moved from Want to Need less than 48
        hours before the trip requires a real defense, not "well, what
        if." The Skip column is your friend here. Make people re-argue
        past their own earlier decision.
      </p>
    </>
  )
}
